<template>
  <a-modal :title="$t('participants.header')" @close="hide">
    <div class="members">
      <div class="members__header" v-if="user.isAssistant">
        <h2>{{ $t('participants.title') }}</h2>
        <a-button variant="link-primary" class="p--0" @click="addMemberHandler">
          <a-icon name="plus-circle" />
        </a-button>
      </div>
      <div class="members__content">
        <a-participants></a-participants>
      </div>
    </div>
    <template #footer>
      <a-button @click="hide"> {{ $t('dialog.button.cancel') }}</a-button>
    </template>
  </a-modal>
</template>

<script setup>
import {useSessionStore, useUserStore, useAppStore} from '@/stores'
import AModal from '@/components/AModal.vue'
import AParticipants from '@/components/AParticipants.vue'

const app = useAppStore()
const session = useSessionStore()
const user = useUserStore()

function addMemberHandler() {
  const {conference: callId} = session
  const {
    configuration: {
      session: {detailUrl},
    },
  } = app
  const url = detailUrl.replace('{{callId}}', callId)
  window.open(url, '_blank')
}

const hide = () => {
  app.transition('HIDE_PARTICIPANTS_MODAL')
}
</script>

<style lang="scss">
.members {
  position: relative;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    padding-bottom: $box-spacer;
    z-index: 1;
    .btn {
      position: relative;
      top: 0;
      right: 0;
    }
  }

}
</style>
